import { render, staticRenderFns } from "./HuascaranReportListPage.vue?vue&type=template&id=7ed6432b&scoped=true"
import script from "./HuascaranReportListPage.vue?vue&type=script&lang=js"
export * from "./HuascaranReportListPage.vue?vue&type=script&lang=js"
import style0 from "./HuascaranReportListPage.vue?vue&type=style&index=0&id=7ed6432b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed6432b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed6432b')) {
      api.createRecord('7ed6432b', component.options)
    } else {
      api.reload('7ed6432b', component.options)
    }
    module.hot.accept("./HuascaranReportListPage.vue?vue&type=template&id=7ed6432b&scoped=true", function () {
      api.rerender('7ed6432b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/HuascaranReportListPage.vue"
export default component.exports